export const HTTP_OK_CODE = 200;
export const INVALID_REFRESH_TOKEN = 1001;
export const PSW_SHOULD_BE_RESET_ERROR_MIGRATED_USER = 1006;
export const PSW_SHOULD_BE_RESET_ADMIN_INITIATED = 1005;
export const PSW_SHOULD_BE_RESET_ERROR_NEW_USER = 1004;
export const PSW_SHOULD_BE_RESET_ERROR_NEW_USER_AWS = 1003;
export const NO_DATA_IN_DB_ERROR = 2001;
export const NETWORK_REQUEST_FAILED = 'Network request failed';

export const UNEXPECTED_ERROR = {
  code: 'unexpectedError',
  message: 'Unexpected error'
};

export const EXPORT_ERROR = {
  code: 'exportError',
  message: 'Error exporting loads, please try again',
  description: 'Error exporting loads, please try again'
};

export const EXPORT_SUCCESS = {
  code: 'exportSuccess',
  message: 'Loads exported successfully',
  description: 'Loads exported successfully'
};
export const NETWORK_ERROR = {
  code: 'networkError',
  message: 'No internet connection!',
  description: 'Please check your internet connection and try again.',
  icon: 'Antenna',
  button: 'Retry'
};

export const NO_DATA_AVAILABLE_ERROR = {
  code: 'noDataError',
  message: 'No Data Available',
  description: 'There is no registered data for this well site.',
  icon: 'information'
};

export const TIMEOUT_ERROR = {
  status: 504,
  code: 'requestTimeOut',
  message: 'Request Time Out',
  description: 'Please check your internet connection and try again.'
};

export const GATEWAY_TIMEOUT_ERROR = {
  code: 504,
  message: 'Request Time Out',
  description: 'Please check your internet connection and try again.'
};

export const REQUEST_TIMEOUT_ERROR = {
  code: 408,
  message: 'Request Time Out',
  description: 'Please check your internet connection and try again.'
};

export const UPDATE_ME_PROFILE_SUCCESS = {
  code: 200,
  message: 'User me profile update success'
};

export const USER_ME_PROFILE_SUCCESS = {
  code: 200,
  message: 'User me profile success'
};

export const INVALID_CREDENTIALS_ERROR = {
  code: 'invalidCredentials',
  message: 'Invalid credentials'
};

export const INVALID_EMAIL_ERROR = {
  code: 'invalidEmail',
  message: 'Invalid email'
};

export const FORGOT_PWD_SUCCESS = {
  code: 200,
  message: 'Password recovery',
  description: `An email has been sent to your registered address. Please follow the instructions to reset your password.`
};

export const RESET_PWD_SUCCESS = {
  code: 200,
  message: 'Password reset successfully',
  description: ``
};

export const LOGIN_SUCCESS = {
  code: 200,
  message: 'Successfully loged',
  description: ``
};

export const LOGIN_SSO_SUCCESS = {
  code: 200,
  message: 'Successfully SSO logged',
  description: ``
};

export const REFRESH_SUCCESS = {
  code: 200,
  message: 'Successfully refreshed',
  description: ``
};

export const BIOMETRIC_LOGIN_SUCCESS = {
  code: 200,
  message: 'Successfully loged',
  description: ''
};

export const REHYDRATED_SUCCESS = {
  code: 200,
  message: 'auth info rehydrated',
  description: ``
};
export const REHYDRATED_SUCCESS_NO_DATA = {
  code: 204,
  message: 'auth info not found',
  description: ``
};

export const CHECK_FOR_BIOMETRICS_HARDWARE_SUCCESS = {
  code: 205,
  message: 'biometric hardware checked',
  description: ``
};

export const STORE_CLEARED = {
  code: 200,
  message: 'secure store cleared',
  description: ``
};

export const CREDENTIALS_CLEARED = {
  code: 200,
  message: 'credentials deleted from device',
  description: ``
};

export const EXPORT_HISTORY_DATA_SUCCESS = {
  code: 202,
  message: 'Data successfully exported',
  description: 'Data has been sent to the email associated to your account'
};

export const USERNAME_AND_PASSWORD_REQUIRED_ERROR = {
  code: 'invalidEmail',
  codeName: 'InvalidEmail',
  message: 'Please enter your email and password'
};

export const INVALID_PASSWORD = {
  code: 'invalidPassword',
  message: 'Invalid Password',
  description:
    'It does not meet the security requirements.\n\n It must contain at least 8 characters with at least one of each of the following rules: numbers, special characters (e.g. /,%,&,*), both upper and lower case letters.'
};

export const AUTH_ERROR = {
  code: 401,
  message: 'Authentication error',
  description: ``
};

export const GET_TRUCKING_DETAILS = 'GET_TRUCKING_DETAILS';
export const CREATE_TRUCKING_DETAILS = 'CREATE_TRUCKING_DETAILS';
export const GET_TRUCKING_DETAILS_LOADED = 'Trucking details loaded correctly';
export const GET_LOADING_FACILITIES = 'GET_LOADING_FACILITIES';
export const GET_LOADING_FACILITIES_LOADED = 'LOADING FACILITIES INFO LOADED';
export const GET_PURCHASE_ORDERS = 'GET PURCHASE ORDERS';
export const GET_PURCHASE_ORDERS_LOADED = 'PURCHASE ORDERS INFO LOADED';
export const GET_WELLSITES_INFO_SUCCESS = {
  code: 'GET_WELLSITES_INFO',
  message: 'WELLSITES INFO LOADED'
};
export const GET_PRODUCT_ORDERS_SUCCESS = {
  code: 'GET_PRODUCT_ORDERS_SUCCESS',
  message: 'PRODUCT ORDER LOADED'
};
export const DELETE_PRODUCT_ORDERS_SUCCESS = {
  code: 'DELETE_PRODUCT_ORDERS_SUCCESS',
  message: 'PRODUCT ORDER DELETED'
};
export const GET_WELLSITES_SUMMARY_SUCCESS = {
  code: 'GET_WELLSITES_SUMMARY',
  message: 'GET WELLSITES SUMMARY LOADED'
};
export const GET_FLEET_HISTORY_SUCCESS = {
  code: 'GET_FLEET_HISTORY',
  message: 'GET WELLSITES HISTORY LOADED'
};
export const NO_WELLSITE_DATA = {
  code: 'nowellsitedata',
  message: 'Please check your filters or contact an administrator for access',
  title: 'Well site data not found',
  description:
    'Please check your filters or contact an administrator for access',
  isCustomError: true
};
export const CATALOG_SORT_BY = {
  wellName: 'wellName',
  fleetName: 'fltFormattedNames'
};
export const SEARCH_COMPANIES_SUCCESS = {
  code: 200,
  message: 'Search companies success'
};
export const SEARCH_LOCATIONS_SUCCESS = {
  code: 200,
  message: 'Search locations success'
};
export const GET_LOCATION_ID_SUCCESS = {
  code: 200,
  message: 'get location success'
};
export const UPDATE_LOCATION_ID_SUCCESS = {
  code: 200,
  message: 'update location success'
};
export const CREATE_COMPANY_ERROR = {
  code: 504,
  message: 'Could not create the company, contact your service provider'
};

export const UPDATE_COMPANY_ERROR = {
  code: 504,
  message: 'Could not update the company, contact your service provider'
};

export const DELETE_COMPANY_ERROR = {
  code: 504,
  message: 'Could not delete the company, contact your service provider'
};

export const CREATE_COMPANY_SUCCESS = {
  code: 204,
  message: 'Company created successfully'
};
export const UPDATE_COMPANY_SUCCESS = {
  code: 205,
  message: 'Company updated successfully'
};
export const DELETE_COMPANY_SUCCESS = {
  code: 200,
  message: 'Deleted Company successfully'
};
export const GET_SINGLE_COMPANY_SUCCESS = {
  code: 200,
  message: 'Get Company by Id success'
};
export const TRANSACTION_ID = 'transactionId';
export const GET_LOAD_CELLS_SUCCESS = {
  code: 'GET_LOAD_CELLS_SUCCESS',
  message: 'LOAD CELLS LOADED'
};
export const TOGGLE_FAV_WELLSITE = {
  code: 'wellSiteToFav',
  added: 'WellSite was added to favorites',
  removed: 'WellSite was removed from favorites'
};
export const NO_WELLSITE_NAME = {
  code: 'noWellSiteName',
  message: 'Well Site Name is required to add/remove it from favorites'
};
export const CREATE_WELL_EVENT_ERROR = {
  code: 504,
  message: 'Could not create the WELL_EVENT, contact your service provider'
};

export const UPDATE_WELL_EVENT_ERROR = {
  code: 504,
  message: 'Could not update the WELL_EVENT, contact your service provider'
};

export const DELETE_WELL_EVENT_ERROR = {
  code: 504,
  message: 'Could not delete the Well Site Event, contact your service provider'
};
export const CREATE_WELL_EVENT_SUCCESS = {
  code: 204,
  message: 'Well Site Event created successfully'
};
export const UPDATE_WELL_EVENT_SUCCESS = {
  code: 205,
  message: 'Well Site Event updated successfully'
};
export const DELETE_WELL_EVENT_SUCCESS = {
  code: 200,
  message: 'Well Site Event deleted successfully'
};
export const GET_SINGLE_WELL_EVENT_SUCCESS = {
  code: 200,
  message: 'Get Well Site Event by Id success'
};
export const GET_WELL_EVENT_SUCCESS = {
  code: 200,
  message: 'Get Well Site Event success'
};

export const GET_WELL_RULES_EVENT_SUCCESS = {
  code: 200,
  message: 'Get Well Site Event Rules success'
};

export const USER_PROFILE_SUCCESS = {
  code: 200,
  message: 'User profile success'
};

export const DRIVERS_RELATED_SUCCESS = {
  code: 200,
  message: 'Drivers related success'
};
export const GENERAL_USERS = 'GeneralUsers';

export const GET_WELL_JOB_SUCCESS = {
  code: 200,
  message: 'Get wellsite completed jobs success'
};
export const GET_TRUCKING_STATUS_SUCCESS = {
  code: 'GET_TRUCKING_STATUS',
  message: 'GET TRUCKING STATUS LOADED'
};
export const GET_TRUCKING_FACILITIES_SUCCESS = {
  code: 'GET_TRUCKING_FACILITIES',
  message: 'GET TRUCKING FACILITIES LOADED'
};
export const EXPORT_TRUCKLOADS_FAILURE = {
  code: 510,
  message: 'Could not export truckloads'
};
export const GET_CONTROL_SUCCESS = {
  code: 200,
  message: 'Control plan load successful'
};
export const CREATE_CONTROL_ERROR = {
  code: 504,
  message: 'Could not create the control, contact your service provider'
};
export const CREATE_LOCATIONS_SUCCESS = {
  code: 200,
  message: 'Add locations success'
};
export const CREATE_LOCATIONS_ERROR = {
  code: 504,
  message: 'Could not create the locations, contact your service provider'
};
export const CREATE_CARRIERS_SUCCESS = {
  code: 200,
  message: 'Get carriers success'
};
export const CREATE_CARRIERS_ERROR = {
  code: 504,
  message: 'Could not create the carriers, contact your service provider'
};
export const UPDATE_CONTROL_ERROR = {
  code: 504,
  message: 'Could not update the control, contact your service provider'
};

export const DELETE_CONTROL_ERROR = {
  code: 504,
  message: 'Could not delete the control, contact your service provider'
};

export const CREATE_CONTROL_SUCCESS = {
  code: 204,
  message: 'Control plan created successfully'
};
export const UPDATE_CONTROL_SUCCESS = {
  code: 205,
  message: 'Control plan updated successfully'
};
export const DELETE_CONTROL_SUCCESS = {
  code: 200,
  message: 'Deleted Control plan successfully'
};
export const GET_SINGLE_CONTROL_SUCCESS = {
  code: 200,
  message: 'Get Control plan by Id success'
};
export const CREATE_FLEET_SUCCESS = {
  code: 204,
  message: 'Fleet created successfully'
};
export const UPDATE_FLEET_SUCCESS = {
  code: 205,
  message: 'Fleet updated successfully'
};
export const DELETE_FLEET_SUCCESS = {
  code: 200,
  message: 'Deleted Fleet successfully'
};
export const GET_SINGLE_FLEET_SUCCESS = {
  code: 200,
  message: 'Get Fleet by Id success'
};
export const GET_FLEET_USERS_SUCCESS = {
  code: 200,
  message: 'Fleet users successfully retrieved'
};
export const DELETE_FLEET_USER_SUCCESS = {
  code: 200,
  message: 'Fleet user successfully deleted'
};
export const UPDATE_FLEET_USERS_SUCCESS = {
  code: 200,
  message: 'Fleet users successfully updated'
};
export const CREATE_FLEET_ERROR = {
  code: 504,
  message: 'Could not create a fleet, contact your service provider'
};

export const UPDATE_FLEET_ERROR = {
  code: 504,
  message: 'Could not update the fleet, contact your service provider'
};

export const DELETE_FLEET_ERROR = {
  code: 504,
  message: 'Could not delete the fleet, contact your service provider'
};
export const GET_FLEET_ERROR_SUCCESS = {
  code: 200,
  message: 'Get fleet error messages success'
};
export const DELETE_FLEET_ERROR_ERROR = {
  code: 504,
  message:
    'Could not delete the fleet error message, contact your service provider'
};
export const DELETE_FLEET_ERROR_SUCCESS = {
  code: 200,
  message: 'Delete fleet error messages success'
};
export const GET_FLEETS_STATUS_SUCCESS = {
  code: 200,
  message: 'Get fleet status catalog success'
};
export const GET_FLEETS_SUCCESS = {
  code: 200,
  message: 'Get fleets success'
};
export const SEARCH_USERS_SUCCESS = {
  code: 200,
  message: 'Search users success'
};
export const GET_USR_BY_GROUP_SUCCESS = {
  code: 200,
  message: 'Get users by success',
  description: `Get all users from speficic group`
};
export const GET_USERS_SUCCESS = {
  code: 200,
  message: 'Get users success'
};
export const GET_GROUPS_SUCCESS = {
  code: 200,
  message: 'Get groups success',
  description: `Get all groups success`
};
export const CREATE_USER_SUCCESS = {
  code: 200,
  message: 'Create user success'
};
export const DELETE_USER_SUCCESS = {
  code: 200,
  message: 'Delete user success'
};
export const DISABLE_USER_SUCCESS = {
  code: 200,
  message: 'Disable user success'
};
export const ENABLE_USER_SUCCESS = {
  code: 200,
  message: 'Enable user success'
};
export const ADD_USR_TO_GROUP_SUCCESS = {
  code: 200,
  message: 'Add user to group success'
};
export const UPDATE_USR_GROUP_SUCCESS = {
  code: 200,
  message: 'Update user group success'
};
export const RMV_USR_TO_GROUP_SUCCESS = {
  code: 200,
  message: 'Remove user to group success'
};
export const CREATE_USER_ERROR = {
  code: 'InvalidDataError',
  message: 'Username, password and company are required'
};
export const CREATE_USER_INVALID_MAIL = {
  code: 'InvalidMailError',
  message: 'Invalid email'
};
export const DELETE_DISABLE_USER_ERROR = {
  code: 'InvalidDataError',
  message: 'Username is required'
};
export const USER_GROUP_ERROR = {
  code: 'InvalidDataError',
  message: 'Username and group are required'
};
export const UPDATE_USER_SUCCESS = {
  code: 200,
  message: 'Settings updated sucessfully'
};
export const GET_DRIVES_INFO_SUCCESS = {
  code: 'GET_DRIVES_INFO',
  message: 'DRIVES INFO LOADED'
};
export const GET_DRIVES_BY_FLEET_SUCCESS = {
  code: 'GET_DRIVES_BY_FLEET_INFO',
  message: 'DRIVES BY FLEET INFO LOADED'
};
export const UPDATE_DRIVES_SUCCESS = {
  code: 'UPDATE_DRIVES_SUCCESS',
  message: 'DRIVES INFO UPDATED'
};
export const DELETE_DRIVES_SUCCESS = {
  code: 'DELETE_DRIVES_SUCCESS',
  message: 'DRIVES INFO DELETED'
};
export const GET_HISTORICAL_GENSETS_SUCCESS = {
  code: 'GET_HISTORICAL_GENSETS_SUCCESS',
  message: 'GENSET HISTORICAL LOADED'
};
export const GET_HISTORICAL_DRIVES_SUCCESS = {
  code: 'GET_HISTORICAL_DRIVES_SUCCESS',
  message: 'DRIVE HISTORICAL LOADED'
};

export const GET_WELLSITE_DETAILS_SUCCESS = {
  code: 200,
  message: 'Get Wellsite details success'
};

export const DEACTIVATE_WELLSITE_FLEETS_SUCCESS = {
  code: 200,
  message: 'Deactivate wellsite fleets success'
};

export const UPDATE_ACCESS_LEVEL_SUCCESS = {
  code: 200,
  message: 'Update access level success'
};

export const DELETE_ACCESS_LEVEL_SUCCESS = {
  code: 200,
  message: 'Delete access level success'
};

export const GET_ACCESS_LEVEL_SUCCESS = {
  code: 200,
  message: 'Get access level success'
};
export const GET_NOTIFICATIONS_SUCCESS = {
  code: 'GET_NOTIFICATIONS_SUCCESS',
  message: 'GET NOTIFICATIONS SETTINGS'
};
export const UPDATE_NOTIFICATIONS_SUCCESS = {
  code: 'UPDATE_NOTIFICATIONS_SUCCESS',
  message: 'UPDATE NOTIFICATIONS SETTINGS UPDATED'
};

export const UPDATE_REVERT_STATUS = {
  code: 200,
  message: 'Update status success'
};

export const UPDATE_ADVANCE_STATUS = {
  code: 200,
  message: 'Advance status success'
};

export const GET_DRIVERS_SUCCESS = {
  code: 200,
  message: 'Get Drivers success'
};

export const GET_TRUCKLOAD_SUCCESS = {
  code: 'getTruckLoadSuccess',
  message: 'Get Truckload success'
};

export const BOL_UPLOAD_SUCCESS = {
  code: 'bolUploadPictureSuccess',
  message: 'Bol Upload Picture Success'
};

export const SET_DIVERT_SUCCESS = {
  code: 200,
  message: 'Load was successfully diverted'
};

export const EXPORT_HISTORY_FAILURE = {
  code: 510,
  message: 'Could not export fleet history'
};

export const GET_RATES_SUCCESS = {
  code: 'getTruckLoadRatesSuccess',
  message: 'Get Truckload Rates success'
};
export const GET_LOG_SUCCESS = {
  code: 'getTruckLoadLogSuccess',
  message: 'Get Truckload Log success'
};

export const VISION_POOL_NAME = 'Vision';
export const LENS_POOL_NAME = 'Lens';
export const OPTICS_POOL_NAME = 'Optics';
export const POWER_POOL_NAME = 'Power';
export const PULSE_POOL_NAME = 'pulse';
export const LENS_OPTICS_POOL_NAME = 'Lens-Optics';
